angular
    .module('WizApp')
    .component('facebookMailForm', {
        controller: [
            '$scope',
            '$window',
            'RegisterService',
            'AuthenticationService',
            'NoticeService',
            function ($scope, $window, RegisterService, AuthenticationService, NoticeService) {
                const vm = this;

                vm.username = null;
                vm.password = null;

                vm.loading = false;
                vm.facebookLoading = false;

                vm.invalidCredentials = false;
                vm.showPasswordInput = false;
                vm.showLostPasswordLink = false;
                vm.lostPasswordSent = false;

                vm.isAnythingLoading = isAnythingLoading;
                vm.forgottenPassword = forgottenPassword;
                vm.onSubmit = onSubmit;

                vm.resetCredentialsValidity = () => { vm.invalidCredentials = false };

                function isAnythingLoading() {
                    return vm.loading || vm.facebookLoading;
                }

                function onSubmit() {
                    vm.loading = true;

                    if (vm.showPasswordInput === false) {
                        RegisterService
                            .registerFacebookEmail(vm.username)
                            .success(function (data) {
                                if (data.status === 'ok') {
                                    location.href = data.redirectTo;
                                } else {
                                    vm.loading = false;
                                }
                            })
                            .error(function (response) {
                                if (response.mail_status === 'ERROR_USER_ALREADY_EXIST') {
                                    vm.showPasswordInput = true;
                                    // Reset form errors generated on facebook_login_password input
                                    vm.loginForm.$setPristine();
                                    vm.loginForm.$setUntouched();
                                }
                                vm.loading = false;
                            })
                        ;
                    }
                    else {
                        const user = { email: vm.username, password: vm.password };

                        RegisterService
                            .loginAccount(user)
                                .then(response => response.data)
                                .then(data => {
                                    $window.location.href = AuthenticationService.getRedirectRoute(data.redirect, true);
                                })
                                .catch(error => {
                                    if (error.status === 403) {
                                        vm.invalidCredentials = true;
                                        vm.lostPasswordSent = false;
                                        vm.showLostPasswordLink = true;
                                    } else {
                                        NoticeService.error('wizbii.core.messages.error.ajaxserver');
                                    }

                                    vm.loading = false;
                                });
                    }
                    return;
                }

                function forgottenPassword() {
                    AuthenticationService
                        .resetPassword(vm.username)
                        .then(response => response.data)
                        .then(() => {
                            vm.invalidCredentials = false;
                            vm.lostPasswordSent = true;
                            vm.showLostPasswordLink = false;
                        })
                        .catch(error => {
                            const status = error.status;
                            if (angular.isNumber(status) && status >= 400 && status < 500) {
                                vm.invalidCredentials = true;
                            } else {
                                NoticeService.error('wizbii.core.messages.error.ajaxserver');
                            }
                        })
                        .finally(() => { vm.formLoading = false });
                }
            }
        ],
        // language=HTML
        template:
        `
            <h3 class="text-center">
                <span ng-if="!$ctrl.showPasswordInput">
                    {[:: 'wizbii.registerlayer.messages.title.emailnotretrieved' | trans ]}
                    <img
                        src="/bundles/wizbiicore/images/sad.png"
                        srcset="/bundles/wizbiicore/images/sad@2x.png"
                        class="icon-35-h3"
                        aria-hidden="true"
                    >
                </span>
                <span ng-if="$ctrl.showPasswordInput && !$ctrl.showLostPasswordLink">
                    <img
                        src="/bundles/wizbiicore/images/warn.png"
                        srcset="/bundles/wizbiicore/images/warn@2x.png"
                        class="icon-35-h3"
                        aria-hidden="true"
                    >
                    {[:: 'wizbii.facebook.error.mail.already.used' | trans ]}
                </span>
                <span ng-if="$ctrl.showPasswordInput && $ctrl.showLostPasswordLink">
                    {[:: 'wizbii.onboarding.messages.action.resetpassword' | trans ]}
                </span>
            </h3>

            <div class="margin-top-gutter margin-bottom-gutter">
                    <span ng-if="!$ctrl.showPasswordInput">
                        {[:: 'wizbii.registerlayer.messages.title.emailreason' | trans ]}
                    </span>
                    <span 
                        class="font-size-large-ish"
                        ng-if="$ctrl.showPasswordInput"
                    >
                        {[:: 'wizbii.onboarding.messages.form.label.bindfacebookconnect' | trans ]}
                    </span>
            </div>
            
            
            <form
                name="$ctrl.loginForm"
                data-ng-submit="$ctrl.onSubmit()"
            >
                
                <form-control
                    type="email"
                    input-id="facebook_login_username"
                    name="email"
                    input-class="form-control form-control--big"
                    ng-model="$ctrl.username"
                    label-class="font-size-tiny"
                    label-text="{{ 'wizbii.onboarding.messages.form.label.email' | trans }}"
                    required
                    on-change="$ctrl.resetCredentialsValidity()"
                    input-disabled="$ctrl.showPasswordInput"
                ></form-control>

                <form-control
                    type="password"
                    input-id="facebook_login_password"
                    name="password"
                    input-class="form-control form-control--big"
                    ng-model="$ctrl.password"
                    label-class="font-size-tiny"
                    label-text="{{ 'wizbii.onboarding.messages.form.label.password' | trans }}"
                    required
                    on-change="$ctrl.resetCredentialsValidity()"
                    ng-if="$ctrl.showPasswordInput"
                ></form-control>

                <div class="text-center margin-top-gutter-ish">
                    <div
                        ng-if="$ctrl.invalidCredentials"
                        class="text-error font-weight-medium text-center"
                    >
                        {[:: 'wizbii.registerlayer.messages.form.invalidcredentials' | trans ]}
                    </div>
                    <div
                        class="link font-weight-medium margin-top-gutter-ish"
                        data-ng-click="$ctrl.forgottenPassword()"
                        ng-if="$ctrl.showLostPasswordLink && !$ctrl.lostPasswordSent"
                    >
                        <a>{[:: 'wizbii.onboarding.messages.title.reinitmotdepasse' | trans ]}</a>
                    </div>
                    <div
                        class="font-weight-medium margin-top-gutter-ish"
                        ng-if="$ctrl.lostPasswordSent && !$ctrl.showLostPasswordLink"
                    >
                        {[:: 'wizbii.registerlayer.messages.label.lostpasswordsent' | trans ]}
                    </div>

                </div>

                <button
                    type="submit"
                    class="button button--block button--facebook margin-top-gutter margin-top-large--sm-up"
                    data-ng-disabled="$ctrl.isAnythingLoading()"
                >
                    <img
                        src="/bundles/wizbiicore/images/v35/logo-bt-facebook.svg"
                        alt=""
                        height="18"
                        width="18"
                        class="v-align-text-top margin-right-inner"
                    />
                    <span ng-if="!$ctrl.showPasswordInput">{[:: 'wizbii.profile.messages.title.connexion' | trans ]}</span>
                    <span ng-if="$ctrl.showPasswordInput">{[:: 'wizbii.onboarding.messages.action.bindfacebook' | trans ]}</span>
                </button>

            </form>
        `
    });
